import Vue from "vue";
import VueRouter from "vue-router";
const indexPage = () => import("../view/indexPage.vue");
const homePage = () => import("../view/homePage.vue");
const userMan = () => import("../view/user/user-man.vue");
const pointMan = () => import("../view/point/point-man.vue");
const pointMan2 = () => import("../view/point/point-man2.vue");

const pointADD = () => import("../view/point/point-add.vue");
const eavADD = () => import("../view/point/eav-add.vue");
const scoreSummary = () => import("../view/score/scoreSummary.vue");
const menuMan = () => import("../view/menu/menu-man.vue");
const evaluationClass = () => import("../view/evaluation/evaluationClass.vue");//测评轮次
const searchClass = () => import("../view/evaluation/searchClass.vue");//测评派发日志
const assessmentType = () => import("../view/evaluation/assessmentType.vue");//测评类型
const surveyRuleConfig = () => import("../view/evaluation/surveyRuleConfig.vue");//动态计分规则
const assessmentContent = () => import("../view/assessment/assessmentContent.vue");//测评内容
const assessmentRectify = () => import("../view/assessment/assessmentRectify.vue");//测评整改
const assessmentAudit = () => import("../view/assessment/assessmentAudit.vue");//测评审核
const assessmentArchive = () => import("../view/assessment/assessmentArchive.vue");//完结归档
const unit = () => import("../view/user/unit.vue");
const roleList = () => import("../view/user/roleList.vue");
const login = () => import("../view/login.vue");
const userLogin = () => import("../view/user/userlog.vue");
const unLogin = () => import("../view/user/unLogin.vue");

const console = () => import("../view/console/console.vue");//控制台
const dataScreen = () => import("../view/home/dataScreen.vue");//数据大屏
const fileMan = () => import("../view/console/fileMan.vue");//附件管理
const statisticsAnalysis = () => import("../view/statistics/statisticsAnalysis.vue");//统计分析
const pendingTasks = () => import("../view/task/pendingTasks.vue");//待处理任务
const taskList = () => import("../view/task/taskList.vue");//任务列表
const taskProcess = () => import("../view/task/taskProcess.vue");//任务处理
const taskAudit = () => import("../view/task/taskAudit.vue");//任务审核
const pendingAudits = () => import("../view/task/pendingAudits.vue");//待审核列表
const taskFlow = () => import("../view/task/taskFlow.vue");//任务流程跟踪
const auditFlowConfig = () => import("../view/audit/auditFlowConfig.vue");//审核流程配置
const messageList = () => import("../view/message/messageList.vue");//消息通知
const scoreAnalysis = () => import("../view/score/scoreAnalysis.vue");//测评成绩
import { getToken, getTitle } from "../utils/utils.js";
Vue.use(VueRouter);
// 重写router的replace和push函数
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  { path: "/", name: "login", component: login },
  {
    path: "/home",
    name: "homePage",
    component: indexPage,
    redirect: "home/console",
    children: [
      { path: "userMan", name: "用户管理", component: userMan },//用户管理
      { path: "unit", name: "单位管理", component: unit },//单位管理
      { path: "pointADD", name: "周边项目添加", component: pointADD },//点位管理 周边项目添加
      { path: "eavADD", name: "测评项目添加", component: eavADD },//点位管理 测评项目添加
      { path: "pointMan", name: "点位管理", component: pointMan, },//点位管理
      { path: "pointMan2", name: "点位管理V2", component: pointMan2, },//点位管理
      { path: "scoreSummary", name: "测评汇总", component: scoreSummary, },//成绩管理 测评汇总
      { path: "menuMan", name: "菜单管理", component: menuMan, },//菜单管理
      { path: "roleList", name: "角色管理", component: roleList, },//角色管理
      { path: "evaluationClass", name: "测评轮次", component: evaluationClass, },//测评轮次
      { path: "searchClass", name: "测评派发日志", component: searchClass, },//测评派发日志
      { path: "assessmentType", name: "测评类型", component: assessmentType, },//测评类型
      { path: "surveyRuleConfig", name: "动态计分规则", component: surveyRuleConfig, },//动态计分规则
      { path: "assessmentContent", name: "测评内容", component: assessmentContent, },//测评内容
      { path: "assessmentRectify", name: "测评整改", component: assessmentRectify, },//测评整改
      { path: "assessmentAudit", name: "测评审核", component: assessmentAudit, },//测评审核
      { path: "assessmentArchive", name: "完结归档", component: assessmentArchive, },//完结归档
      { path: "dataScreen", name: "数据大屏", component: dataScreen, },//数据大屏
      { path: "console", name: "控制台", component: console, },//控制台
      { path: "userLogin", name: "用户日志", component: userLogin, },//用户日志
      { path: "unLogin", name: "未登录管理", component: unLogin, },//未登录管理
      { path: "fileMan", name: "附件管理", component: fileMan, },//附件管理
      { path: "statisticsAnalysis", name: "统计分析", component: statisticsAnalysis, },//统计分析
      { path: "pendingTasks", name: "待处理任务", component: pendingTasks, },//待处理任务
      { path: "taskList", name: "任务列表", component: taskList, },//任务列表
      { path: "taskProcess", name: "任务处理", component: taskProcess, },//任务处理
      { path: "taskAudit", name: "任务审核", component: taskAudit, },//任务审核
      { path: "pendingAudits", name: "待审核列表", component: pendingAudits, },//待审核列表
      { path: "taskFlow", name: "任务流程跟踪", component: taskFlow, },//任务流程跟踪
      { path: "auditFlowConfig", name: "审核流程配置", component: auditFlowConfig, },//审核流程配置
      { path: "messageList", name: "消息通知", component: messageList, },//消息通知
      { path: "scoreAnalysis", name: "测评成绩", component: scoreAnalysis, },//测评成绩

    ],
  },
];
const router = new VueRouter({ routes });
// 全局路由拦截，拦截用户是否登录
router.beforeEach((to, from, next) => {
  let toPath = to.path;

  document.title = getTitle(toPath);
  if (toPath === "/") {
    return next();
  }
  // 判断token是否有
  let token = getToken();
  if (!token) {
    return next("/");
  }
  next();
});
export default router;
